import {
    ROLE_ADD,
    ROLE_APPROVE,
    ROLE_EDIT,
    ROLE_ITEM_DELETE_REQUEST,
    ROLE_ITEM_DELETE_RESPONSE,
    ROLE_ITEM_ERROR_RESPONSE,
    ROLE_ITEM_SAVE_REQUEST,
    ROLE_ITEM_SAVE_RESPONSE,
    ROLE_LIST_CACHED_RESPONSE,
    ROLE_LIST_ERROR_RESPONSE,
    ROLE_LIST_REQUEST,
    ROLE_LIST_RESPONSE,
    ROLE_REJECT,
    ROLE_REMOVE
} from "./action-types"
import {
    itemDeleteResponse,
    itemErrorResponse,
    itemSaveRequest,
    itemSaveResponse,
    itemSubresourceDeleteRequest
} from "./default-actions/entity-actions"
import {
    listCachedResponse,
    listErrorResponse,
    listRequest,
    listResponse
} from "./default-actions/paging-actions"

// List
export const roleListRequest = listRequest(ROLE_LIST_REQUEST)
export const roleListResponse = listResponse(ROLE_LIST_RESPONSE)
export const roleListCachedResponse = listCachedResponse(
    ROLE_LIST_CACHED_RESPONSE
)
export const roleListErrorResponse = listErrorResponse(ROLE_LIST_ERROR_RESPONSE)

// Item
export const roleItemSaveRequest = itemSaveRequest(ROLE_ITEM_SAVE_REQUEST)
export const roleItemSaveResponse = itemSaveResponse(ROLE_ITEM_SAVE_RESPONSE)
export const roleItemDeleteRequest = itemSubresourceDeleteRequest(
    ROLE_ITEM_DELETE_REQUEST
)
export const roleItemDeleteResponse = itemDeleteResponse(
    ROLE_ITEM_DELETE_RESPONSE
)
export const roleItemErrorResponse = itemErrorResponse(ROLE_ITEM_ERROR_RESPONSE)

export const roleAdd = role => ({
    type: ROLE_ADD,
    role
})
export const roleRemove = roleID => ({
    type: ROLE_REMOVE,
    roleID
})
export const roleEdit = role => ({
    type: ROLE_EDIT,
    role
})
export const roleApprove = role => ({
    type: ROLE_APPROVE,
    role
})
export const roleReject = role => ({
    type: ROLE_REJECT,
    role
})
